import React, { useEffect, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import { get } from "../helpers/Dashboard";


export default function Dashboard() {
    const { appState } = useAppState();
    const [dashboard, setDashboard] = useState<any>()

    useEffect(() => {
        get().then((result) => {
            setDashboard(result)
        })
    }, [])


    return (
        <>
            <div className="flex justify-between items-center">
                <h1 className="text-xl">Dashboard</h1>
            </div>
            <div className="mt-3 grid grid-cols-3 gap-4">
                <div className="px-10 py-5 space-y-1 rounded bg-white">
                    <div>Invoices</div>
                    <div className="text-3xl">
                        {dashboard?.invoices.total ?? 0}
                    </div>
                </div>
                <div className="px-10 py-5 space-y-1 rounded bg-white">
                    <div>Unpaid invoices</div>
                    <div className="text-3xl">
                        {dashboard?.invoices.unpaid ?? 0}
                    </div>
                </div>
                <div className="px-10 py-5 space-y-1 rounded bg-white">
                    <div>Clients</div>
                    <div className="text-3xl">
                        {dashboard?.clients.total ?? 0}
                    </div>
                </div>
            </div>
        </>
    );
}
